import React from "react";
import Header from "../layouts/header";
import Sidebar from "../layouts/sidebar";
import Layout from "../layouts/layout";
import PageHeading from "../layouts/pageHeading";
import Index from "../components/capCourseManagement";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link as MuiLink, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { cssProperties } from "../utils/commonCssProperties";
import Cookies from "js-cookie";

export default function CapCourseManagement() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const naviagte = useNavigate();

  const handleClick = () => {
    if (page === "addcourse" || page === "updatecourse" || page === "createcourse") {
      naviagte(`/${Cookies.get("mhet_mst_project")}/course-management?page=capcourselist`);
    }
  };

  const breadcrumbs = [
    <MuiLink
      underline="hover"
      key="1"
      component={NavLink}
      to={`/${Cookies.get("mhet_mst_project")}/home`}
      sx={{
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Dashboard
    </MuiLink>,
    <Typography
      key="3"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: page === "capcourselist"  ? "bold" : 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
        ":hover":{
          textDecoration: page === "capcourselist" ? "none" : "underline",
          cursor : page === "capcourselist" ? "none" : "pointer"
        }
      }}
      onClick={page === "capcourselist" ? undefined : handleClick}
    >
      Cap Course Management {page === "capcourselist" && <MdKeyboardArrowDown size={16} /> }
    </Typography>,
  ];

  if (page === "addcourse") {
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Add Course<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }else if (page === "updatecourse"){
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Update Course<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }else if (page === "createcourse"){
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Create Course<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs}/>
      <Sidebar />
      <Layout>
        <PageHeading
          title={
            page === "capcourselist"
              ? "Cap Course Management"
              : page === "addcourse"
              ? "Add Course"
              : page === "updatecourse"
              ? "Update Course"
              : page === "createcourse"
              ? "Create Course"
              : null
          }
        />
        <Index />
      </Layout>
    </>
  );
}
